import { render } from "./ChatManagement.vue?vue&type=template&id=4b2d64a6"
import script from "./ChatManagement.vue?vue&type=script&lang=js"
export * from "./ChatManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__